export default __webpack_public_path__ + "static/media/cross-gray.3db28092.svg";